import type { ModuleKey, ModuleSelection } from '@pixerito/api-client';
import { Switch } from './ui';

export const MODULES: { type: ModuleKey; label: string; description: string }[] = [
  { type: 'social', label: 'Redes Sociais', description: 'Seguidores, alcance, engajamento e visitas ao perfil.' },
  { type: 'site', label: 'Site', description: 'Visitas, origem do tráfego e conversões.' },
  { type: 'gmb', label: 'Google Meu Negócio', description: 'Visualizações, ações, avaliações e nota.' },
  { type: 'brand', label: 'Identidade Visual', description: 'Central de Entregáveis: status, arquivo final e versões.' },
  { type: 'video', label: 'Vídeo', description: 'Entregáveis de gravação e edição.' },
];

export function defaultModules(): ModuleSelection[] {
  return MODULES.map((m) => ({ type: m.type, enabled: false, isRecurring: false }));
}

export function ModuleToggles({ value, onChange }: { value: ModuleSelection[]; onChange: (v: ModuleSelection[]) => void }) {
  const set = (type: ModuleKey, patch: Partial<ModuleSelection>) => onChange(value.map((m) => (m.type === type ? { ...m, ...patch } : m)));

  return (
    <div className="module-toggles">
      {MODULES.map((def) => {
        const sel = value.find((m) => m.type === def.type) ?? { type: def.type, enabled: false, isRecurring: false };
        return (
          <div key={def.type} className={`module-toggle ${sel.enabled ? 'module-toggle--on' : ''}`}>
            <Switch checked={sel.enabled} onChange={(v) => set(def.type, { enabled: v })} label={def.label} description={def.description} />
            {def.type === 'video' && sel.enabled && (
              <Switch
                checked={sel.isRecurring}
                onChange={(v) => set('video', { isRecurring: v })}
                label="Serviço recorrente"
                description="Mostra os vídeos do mês com views, curtidas, comentários e compartilhamentos."
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
